import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import ReCAPTCHA  from 'react-google-recaptcha';

import TextInput from '../../../Shared/Form/Inputs/TextInput';
import Api from '../../../Shared/Helpers/Api';
import Validator from '../../../Shared/Helpers/Validator';
import MaskedInput from 'react-text-mask';
import { STEPS } from './constants';


export default class CallForm extends React.Component {

    constructor(props) {
        super();

        this.state = {
            inputData: {
                name: "",
                phone: ""
            },
          
            currentStep: STEPS.GENERAL_DETAILS,
            errors: {},
            thankMessage: null,
            data: {
                centers: [],
                hours: [],
                serviceTypes: [],
                sheduleTimes: [],
                cars: [],
                callThankMessage: null
            },
           
            captcha: null
        };

        this.setCallFormState = this.setCallFormState.bind(this);
        this.setCaptha = this.setCaptha.bind(this);
    }


    componentDidMount() {
        Api.getAppointmentData().then((res) => {
            this.setState({
                data: res
            });
        });
    }

    get isFormActive() {
        return this.state.currentStep === STEPS.GENERAL_DETAILS ||
            this.state.currentStep === STEPS.PERSONAL_DETAILS;
    }

    submitRequest() {
        if (this.isValid()) {
            let response = Api.sendCallForm(this.state.inputData)
                .then((res) => {
                    let nextStep = res.ok ? STEPS.THANK_YOU : STEPS.ERROR;

                    this.setState({
                        currentStep: nextStep,
                        isBusy: false
                    });
                });
        }
    }

    // in react-google-recaptcha this field is required
    onChange(value) { }

    setCaptha(el) {
        this.setState({
            captcha: el
        });
    }

    setCallFormState(e) {
        let field = e.target.name;
        let value = e.target.value;

        this.state.inputData[field] = value;

        return this.setState({
            inputData: this.state.inputData
        });
    }

    isValid() {
        let isValid = false;
        this.state.errors = {};
        let form = this.state.inputData;

        if (!Validator.name(form.name)) {
            this.state.errors['name'] = 'Please enter your name';
        }

        if (!Validator.callFormPhone(form.phone)) {
            this.state.errors['phone'] = 'Please enter a valid phone number!';
        }

        //if (!this.state.captcha.getValue()) {
        //    this.state.errors['captcha'] = 'Please check the captcha';
        //}

        this.setState({
            errors: this.state.errors
        });

        if (!Object.keys(this.state.errors).length) {
            isValid = true;
        }

        return isValid;
    }


    render() {
        let viewData = this.state.data;
        let view = null;

            if (this.isFormActive) {
                console.log(this.state.errors['phone']);
                view = (<form className="call-form">
                    <p className="text">Call Us at {this.props.dealerPhone} <br/> or we can call you ! </p>
                    <p className="text" style={{ fontWeight: 'bold' }}>Please enter details below so we may get in touch with you :</p>
                    <fieldset>
                        <TextInput
                            placeholder="Full Name"
                            name="name"
                            onChange={this.setCallFormState}
                            isInvalid={this.state.errors['name']}
                        />

                        <MaskedInput
                            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            placeholder="Phone number"
                            name="phone"
                            className={this.state.errors['phone'] === 'Please enter a valid phone number!' ? "a-input invalid" :"a-input" }
                            onChange={this.setCallFormState}
                            isInvalid={this.state.errors['phone']}
                        />

                        <ReCAPTCHA
                            ref={this.setCaptha}
                            id={"recaptcha-" + 0}
                            className="recaptcha-widget"
                            sitekey="6LcfSkAUAAAAAA-xHDC03d2rghgPjkWMf7Mgd5eU"
                            onChange={this.onChange}
                        />
                    </fieldset>

                    <button type="button" className="apply-btn-white" onClick={() => this.submitRequest()}>CALL ME BACK!</button>
                </form>);
            }
            else {
                if (this.state.currentStep === STEPS.THANK_YOU) {
                    view = <ThankYouScreen phone={this.props.dealerPhone} thankMessage={this.state.data.callThankMessage} />;
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'callMeBackSuccessful',
                    });
                }
                if (this.state.currentStep === STEPS.ERROR) {
                    view = <ErrorScreen />;
                }
            }
        
        return (
            <div className="appointment-scheduler">              
                <div className="b-content">
                    {view}
                </div>
            </div>
        );
    }
}


function ThankYouScreen(props) {

    return (<div className="thank-you-wrapper centered-section">
        <img className="main-icon" src="/images/appointment/icon-success.svg" />
        <h3 className="step-title">
            Thank you
        </h3>
        <h4 className="subtitle">
            Your request has been sent successfully.
        </h4>
        {            
            props.thankMessage !== null &&
            <small className="disclaimer" dangerouslySetInnerHTML={{ __html: props.thankMessage }}/>
        }
        {
            props.thankMessage == null &&
            <small className="disclaimer">
                One of our representatives will contact you shortly
              <br />
                If this is an emergency please contact our center by phone {" "}
                <a href={`tel:${props.phone}`}>
                    {props.phone}
                </a>
            </small>
        }       
    </div>);
}

function ErrorScreen(props) {
    return (<div className="error-wrapper centered-section">
        <h3 className="step-title error">
            Error
            </h3>
        Please contact support
        
    </div>);
}



//let DOMcontainers = [...document.getElementsByClassName('js-callform-component')];

//DOMcontainers.forEach((container, idx) => {
//    ReactDOM.render(<CallForm {...(root.dataset) }/>, container);
//});

var root = document.getElementsByClassName('js-callform-component');
if (root && root[0]) {
    ReactDOM.render(<CallForm {...(root[0].dataset) } />, root[0]);
}



// WEBPACK FOOTER //
// ./Src/Components/CallForm/CallForm/CallForm.jsx